import { useEffect, useState } from "react";
import myaxios from "lib/myAxios";
import { ID } from "lib/common/types/board";
import Image from "lib/components/atomic/Image";
import KhaltiLogo from "../../../../public/img/khalti.png";
import { host } from "utils/constants";
import { message } from "antd";
import { useRouter } from "next/router";
import { ArrowSquareOut } from "@phosphor-icons/react";

export interface KhaltiPaymentProps {
  fee: number;
  classroomId: string;
  registrantInfo: { _id: ID; isVerified: boolean };
  onNext?: () => void;
}

function KhaltiPayment({
  fee,
  classroomId,
  registrantInfo,
  onNext,
}: KhaltiPaymentProps) {
  const amount = fee;
  const [initiating, setInitiating] = useState(false);
  const router = useRouter();

  const data = {
    return_url: typeof window !== "undefined" ? window.location.href : "",
    purchase_order_id: registrantInfo
      ? "classroom@" + classroomId + "@" + registrantInfo._id["$oid"]
      : null,
    purchase_order_name: "Clamphook Class",
    website_url: "https://clamphook.com/",
    amount: fee,
  };

  const verifyPayment = (pidx: string, pid: string, amount: number) => {
    const postUrl = host + "eu/classroom/payment/verify/khalti";
    myaxios
      .put(postUrl, {
        pid: pid,
        pidx: pidx,
        amount: amount,
      })
      .then((response) => {
        if (response.status === 200) {
          message.success("Payment Successful");
          window.location.reload();
        }
      });
  };

  useEffect(() => {
    const urlQueryParams = router.query;
    let pidx: string = (urlQueryParams.pidx as string) || "";
    let pid: string = (urlQueryParams.purchase_order_id as string) || "";
    if ("pidx" in urlQueryParams && "purchase_order_id" in urlQueryParams) {
      verifyPayment(pidx, pid, amount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const initiatePayment = () => {
    setInitiating(true);
    message.info("Redirecting to Khalti...");
    const postUrl = host + "eu/classroom/payment/khalti/initiate";
    myaxios
      .post(postUrl, data)
      .then((response) => {
        const theData = JSON.parse(response.data.data);
        const paymentURL = theData.payment_url;
        if (!paymentURL) {
          message.error(
            "Could not initiate Khalti payment. Please try again or use a different payment method.",
          );
          setInitiating(false);
          return;
        }
        window.location.href = paymentURL;
      })
      .catch(() => {
        message.error("Could not initiate Khalti payment. Please try again.");
        setInitiating(false);
      });
  };

  return (
    <button
      type="button"
      onClick={initiatePayment}
      disabled={initiating}
      className="w-full flex items-center gap-3 p-4 text-left rounded-2xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-[#5c2d91] dark:hover:border-[#5c2d91] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <div className="h-11 w-11 rounded-xl bg-[#5c2d91]/10 flex items-center justify-center shrink-0">
        <Image
          cdn={false}
          src={KhaltiLogo}
          alt="Khalti"
          className="h-9 w-9 object-contain"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="flex items-center gap-1 text-sm font-bold text-gray-900 dark:text-gray-100">
          {initiating ? "Redirecting..." : "Pay with Khalti"}
          <ArrowSquareOut size={13} className="text-gray-400 dark:text-gray-500 shrink-0" />
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Wallet, eBanking or Connect IPS · Rs. {fee}
        </p>
      </div>
    </button>
  );
}

export default KhaltiPayment;
